/**
 * Sample React Native App
 * https://github.com/facebook/react-native
 *
 * Generated with the TypeScript template
 * https://github.com/react-native-community/react-native-template-typescript
 *
 * @format
 */

import { StyleSheet } from 'react-native';
import React, { useEffect, useRef } from 'react';

import { useAuthStore } from '@stores/auth';

import { SplashScreenProps } from './types';
import logoPath from './logo.svg';
const styles = StyleSheet.create({
  root: {
    height: '100%',
    position: 'relative',
  },
  splash: {
    backgroundColor: 'red',
    position: 'absolute',
    zIndex: 1,
    top: 0,
    left: 0,
    height: '100%',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
  },
  logo: {
    width: '30%',
  },
  text: {
    marginTop: 60,
    color: 'white',
    fontWeight: '300',
  },
});

function fadeOut(elemet: HTMLDivElement, time: number) {
  const steps = 50;
  const tick = time / steps;

  const fadeEffect = setInterval(function () {
    const opacity = elemet.style.opacity ? Number(elemet.style.opacity) : 1;

    if (opacity > 0) {
      elemet.style.opacity = `${opacity - 0.1}`;
    } else {
      elemet.remove();
      clearInterval(fadeEffect);
    }
  }, tick);
}

export const SplashScreen: React.FC<SplashScreenProps> = ({ children }) => {
  const splashRef = useRef<HTMLDivElement | null>(null);
  const { initialised } = useAuthStore();

  useEffect(() => {
    if (initialised) {
      setTimeout(() => {
        fadeOut(splashRef.current!, 500);
      }, 500);
    }
  }, [initialised]);

  return (
    <div style={styles.root}>
      <div style={styles.splash} ref={splashRef}>
        <img style={styles.logo} src={logoPath} />
        <h1 style={styles.text}>Live Tracker</h1>
      </div>
      {children}
    </div>
  );
};
